// Adapt height to window resolution
function resizeContainer(){
    const footerh = $("footer").outerHeight();
    const headerh = $("header").outerHeight();
    $('.all-height').css({ minHeight: ($(window).outerHeight() - footerh - headerh )+ 'px' });
};
$(function() {
    $(window).resize(resizeContainer());
    resizeContainer();
});